import { __esmMin as e } from "../_virtual/_rolldown/runtime.es.js";
import t, { init_aiAvatarIcon as n } from "../assets/icons/aiAvatarIcon.svg_raw.es.js";
import ee, { init_aiSparkleIcon as te } from "../assets/icons/aiSparkleIcon.svg_raw.es.js";
import ne, { init_aiSparkleIconBlack as r } from "../assets/icons/aiSparkleIconBlack.svg_raw.es.js";
import i, { init_apiResponse as a } from "../assets/icons/apiResponse.svg_raw.es.js";
import o, { init_aqlBranchIcon as s } from "../assets/icons/aqlBranchIcon.svg_raw.es.js";
import c, { init_arrow_right as l } from "../assets/icons/arrow-right.svg_raw.es.js";
import u, { init_backRightIcon as d } from "../assets/icons/backRightIcon.svg_raw.es.js";
import f, { init_backspace as p } from "../assets/icons/backspace.svg_raw.es.js";
import m, { init_basicBranchIcon as h } from "../assets/icons/basicBranchIcon.svg_raw.es.js";
import g, { init_booleanDataTypeIcon as _ } from "../assets/icons/booleanDataTypeIcon.svg_raw.es.js";
import v, { init_bot as y } from "../assets/icons/bot.svg_raw.es.js";
import b, { init_check_circle as x } from "../assets/icons/check-circle.svg_raw.es.js";
import S, { init_chevronRightPrimary as C } from "../assets/icons/chevronRightPrimary.svg_raw.es.js";
import w, { init_circular_progress as T } from "../assets/icons/circular_progress.svg_raw.es.js";
import E, { init_close as D } from "../assets/icons/close.svg_raw.es.js";
import O, { init_closeWhiteIcon as k } from "../assets/icons/closeWhiteIcon.svg_raw.es.js";
import A, { init_collapse_icon as j } from "../assets/icons/collapse-icon.svg_raw.es.js";
import M, { init_continuenode as N } from "../assets/icons/continuenode.svg_raw.es.js";
import P, { init_copyContentIcon as F } from "../assets/icons/copyContentIcon.svg_raw.es.js";
import I, { init_copyContentIconColor as L } from "../assets/icons/copyContentIconColor.svg_raw.es.js";
import R, { init_cortexSparkIcon as z } from "../assets/icons/cortexSparkIcon.svg_raw.es.js";
import B, { init_expand_icon as V } from "../assets/icons/expand-icon.svg_raw.es.js";
import H, { init_file_text as U } from "../assets/icons/file-text.svg_raw.es.js";
import W, { init_fileUploadIcon as G } from "../assets/icons/fileUploadIcon.svg_raw.es.js";
import re, { init_formulaIcon as K } from "../assets/icons/formulaIcon.svg_raw.es.js";
import q, { init_integerDataTypeIcon as J } from "../assets/icons/integerDataTypeIcon.svg_raw.es.js";
import Y, { init_listDataTypeIcon as X } from "../assets/icons/listDataTypeIcon.svg_raw.es.js";
import ie, { init_lock_keyhole as ae } from "../assets/icons/lock-keyhole.svg_raw.es.js";
import oe, { init_mySql as se } from "../assets/icons/mySql.svg_raw.es.js";
import ce, { init_netomi_logo as le } from "../assets/icons/netomi-logo.svg_raw.es.js";
import ue, { init_nodeIconBreak as de } from "../assets/icons/nodeIconBreak.svg_raw.es.js";
import fe, { init_numberDateTypeIcon as pe } from "../assets/icons/numberDateTypeIcon.svg_raw.es.js";
import me, { init_objectDataTypeIcon as he } from "../assets/icons/objectDataTypeIcon.svg_raw.es.js";
import ge, { init_openInNew as _e } from "../assets/icons/openInNew.svg_raw.es.js";
import ve, { init_paperclip as ye } from "../assets/icons/paperclip.svg_raw.es.js";
import be, { init_plusPrimaryIcon as xe } from "../assets/icons/plusPrimaryIcon.svg_raw.es.js";
import Se, { init_restartChatIcon as Ce } from "../assets/icons/restartChatIcon.svg_raw.es.js";
import we, { init_sendIcon as Te } from "../assets/icons/sendIcon.svg_raw.es.js";
import Ee, { init_stringDataTypeIcon as De } from "../assets/icons/stringDataTypeIcon.svg_raw.es.js";
import Oe, { init_trash as ke } from "../assets/icons/trash.svg_raw.es.js";
import Ae, { init_trashIconPrimary as je } from "../assets/icons/trashIconPrimary.svg_raw.es.js";
import Me, { init_visibilityOn as Ne } from "../assets/icons/visibilityOn.svg_raw.es.js";
import Pe, { init_warningIcon as Fe } from "../assets/icons/warningIcon.svg_raw.es.js";
// libs/ui-lib/src/lib/iconAssets.ts
function Ie(e) {
	return e in Z;
}
function Le(e) {
	if (e in Q) return Q[e];
}
var Z, Q, $ = e((() => {
	n(), te(), r(), a(), s(), l(), d(), p(), h(), _(), y(), x(), C(), T(), D(), k(), j(), N(), F(), L(), z(), V(), U(), G(), K(), J(), X(), ae(), se(), le(), de(), pe(), he(), _e(), ye(), xe(), Ce(), Te(), De(), ke(), je(), Ne(), Fe(), Z = {
		"ai-avatar-icon": {
			name: "ai-avatar-icon",
			path: "@/assets/icons/aiAvatarIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"ai-sparkle-icon": {
			name: "ai-sparkle-icon",
			path: "@/assets/icons/aiSparkleIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"ai-sparkle-icon-black": {
			name: "ai-sparkle-icon-black",
			path: "@/assets/icons/aiSparkleIconBlack.svg",
			type: "svg",
			inlineable: !0
		},
		"api-response": {
			name: "api-response",
			path: "@/assets/icons/apiResponse.svg",
			type: "svg",
			inlineable: !0
		},
		"aql-branch-icon": {
			name: "aql-branch-icon",
			path: "@/assets/icons/aqlBranchIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"arrow-right": {
			name: "arrow-right",
			path: "@/assets/icons/arrow-right.svg",
			type: "svg",
			inlineable: !0
		},
		"back-right-icon": {
			name: "back-right-icon",
			path: "@/assets/icons/backRightIcon.svg",
			type: "svg",
			inlineable: !0
		},
		backspace: {
			name: "backspace",
			path: "@/assets/icons/backspace.svg",
			type: "svg",
			inlineable: !0
		},
		"basic-branch-icon": {
			name: "basic-branch-icon",
			path: "@/assets/icons/basicBranchIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"boolean-data-type-icon": {
			name: "boolean-data-type-icon",
			path: "@/assets/icons/booleanDataTypeIcon.svg",
			type: "svg",
			inlineable: !0
		},
		bot: {
			name: "bot",
			path: "@/assets/icons/bot.svg",
			type: "svg",
			inlineable: !0
		},
		"check-circle": {
			name: "check-circle",
			path: "@/assets/icons/check-circle.svg",
			type: "svg",
			inlineable: !0
		},
		"chevron-right-primary": {
			name: "chevron-right-primary",
			path: "@/assets/icons/chevronRightPrimary.svg",
			type: "svg",
			inlineable: !0
		},
		"circular-progress": {
			name: "circular-progress",
			path: "@/assets/icons/circular_progress.svg",
			type: "svg",
			inlineable: !0
		},
		close: {
			name: "close",
			path: "@/assets/icons/close.svg",
			type: "svg",
			inlineable: !0
		},
		"close-white-icon": {
			name: "close-white-icon",
			path: "@/assets/icons/closeWhiteIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"collapse-icon": {
			name: "collapse-icon",
			path: "@/assets/icons/collapse-icon.svg",
			type: "svg",
			inlineable: !0
		},
		continuenode: {
			name: "continuenode",
			path: "@/assets/icons/continuenode.svg",
			type: "svg",
			inlineable: !0
		},
		"copy-content-icon": {
			name: "copy-content-icon",
			path: "@/assets/icons/copyContentIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"copy-content-icon-color": {
			name: "copy-content-icon-color",
			path: "@/assets/icons/copyContentIconColor.svg",
			type: "svg",
			inlineable: !0
		},
		"cortex-spark-icon": {
			name: "cortex-spark-icon",
			path: "@/assets/icons/cortexSparkIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"expand-icon": {
			name: "expand-icon",
			path: "@/assets/icons/expand-icon.svg",
			type: "svg",
			inlineable: !0
		},
		"file-text": {
			name: "file-text",
			path: "@/assets/icons/file-text.svg",
			type: "svg",
			inlineable: !0
		},
		"file-upload-icon": {
			name: "file-upload-icon",
			path: "@/assets/icons/fileUploadIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"formula-icon": {
			name: "formula-icon",
			path: "@/assets/icons/formulaIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"integer-data-type-icon": {
			name: "integer-data-type-icon",
			path: "@/assets/icons/integerDataTypeIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"list-data-type-icon": {
			name: "list-data-type-icon",
			path: "@/assets/icons/listDataTypeIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"lock-keyhole": {
			name: "lock-keyhole",
			path: "@/assets/icons/lock-keyhole.svg",
			type: "svg",
			inlineable: !0
		},
		"my-sql": {
			name: "my-sql",
			path: "@/assets/icons/mySql.svg",
			type: "svg",
			inlineable: !0
		},
		"netomi-logo": {
			name: "netomi-logo",
			path: "@/assets/icons/netomi-logo.svg",
			type: "svg",
			inlineable: !0
		},
		"node-icon-break": {
			name: "node-icon-break",
			path: "@/assets/icons/nodeIconBreak.svg",
			type: "svg",
			inlineable: !0
		},
		"number-date-type-icon": {
			name: "number-date-type-icon",
			path: "@/assets/icons/numberDateTypeIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"object-data-type-icon": {
			name: "object-data-type-icon",
			path: "@/assets/icons/objectDataTypeIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"open-in-new": {
			name: "open-in-new",
			path: "@/assets/icons/openInNew.svg",
			type: "svg",
			inlineable: !0
		},
		paperclip: {
			name: "paperclip",
			path: "@/assets/icons/paperclip.svg",
			type: "svg",
			inlineable: !0
		},
		"plus-primary-icon": {
			name: "plus-primary-icon",
			path: "@/assets/icons/plusPrimaryIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"restart-chat-icon": {
			name: "restart-chat-icon",
			path: "@/assets/icons/restartChatIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"send-icon": {
			name: "send-icon",
			path: "@/assets/icons/sendIcon.svg",
			type: "svg",
			inlineable: !0
		},
		"string-data-type-icon": {
			name: "string-data-type-icon",
			path: "@/assets/icons/stringDataTypeIcon.svg",
			type: "svg",
			inlineable: !0
		},
		trash: {
			name: "trash",
			path: "@/assets/icons/trash.svg",
			type: "svg",
			inlineable: !0
		},
		"trash-icon-primary": {
			name: "trash-icon-primary",
			path: "@/assets/icons/trashIconPrimary.svg",
			type: "svg",
			inlineable: !0
		},
		"visibility-on": {
			name: "visibility-on",
			path: "@/assets/icons/visibilityOn.svg",
			type: "svg",
			inlineable: !0
		},
		"warning-icon": {
			name: "warning-icon",
			path: "@/assets/icons/warningIcon.svg",
			type: "svg",
			inlineable: !0
		}
	}, Q = {
		"ai-avatar-icon": t,
		"ai-sparkle-icon": ee,
		"ai-sparkle-icon-black": ne,
		"api-response": i,
		"aql-branch-icon": o,
		"arrow-right": c,
		"back-right-icon": u,
		backspace: f,
		"basic-branch-icon": m,
		"boolean-data-type-icon": g,
		bot: v,
		"check-circle": b,
		"chevron-right-primary": S,
		"circular-progress": w,
		close: E,
		"close-white-icon": O,
		"collapse-icon": A,
		continuenode: M,
		"copy-content-icon": P,
		"copy-content-icon-color": I,
		"cortex-spark-icon": R,
		"expand-icon": B,
		"file-text": H,
		"file-upload-icon": W,
		"formula-icon": re,
		"integer-data-type-icon": q,
		"list-data-type-icon": Y,
		"lock-keyhole": ie,
		"my-sql": oe,
		"netomi-logo": ce,
		"node-icon-break": ue,
		"number-date-type-icon": fe,
		"object-data-type-icon": me,
		"open-in-new": ge,
		paperclip: ve,
		"plus-primary-icon": be,
		"restart-chat-icon": Se,
		"send-icon": we,
		"string-data-type-icon": Ee,
		trash: Oe,
		"trash-icon-primary": Ae,
		"visibility-on": Me,
		"warning-icon": Pe
	};
}));
$();
export { Le as getIconSvgContent, Ie as hasIconAsset, Z as iconAssets, Q as iconSvgContent, $ as init_iconAssets };
